import { nanoid } from "@reduxjs/toolkit";
import { addNotification, removeNotification, type NotificationType } from "./notificationSlice";
import type { AppDispatch } from "../../app/store";

export const notify = (message: string, type: NotificationType = "info", timeoutMs = 5000) =>
    (dispatch: AppDispatch) => {
        const id = nanoid();

        dispatch(addNotification({ id, message, type }));

        setTimeout(() => {
            dispatch(removeNotification(id));
        }, timeoutMs);

        return id;
    };
